<template>
  <div
    class="container p-0 hm-min-height-medium"
    :class="{ 'media-form-modal--lg': showSelectMedia }"
  >
    <HMModalHeader
      :title="$t('PRODUCTS.TITLE.ADD_MEDIA')"
      @close="$emit('close')"
    />
    <div v-if="!formModel.media" class="upload">
      <div class="mt-3 pb-5 pb-sm-0 force-width" v-if="showSelectMedia">
        <MediaSearchSection class="pt-2" v-model="searchQuery" />
        <HMPaginatedTable
          ref="media-form-table"
          api="mediaLibrary/getMedia"
          :query="searchQuery"
          name="media-form-table"
        >
          <template slot-scope="{ data }">
            <div class="mt-4 row">
              <div
                class="column col-md-4"
                v-for="mediaItem in data.res.results"
                :key="mediaItem.id"
              >
                <MediaItemCard
                  :animated="false"
                  :isSelectable="true"
                  @selectionChanged="toggleMediaItem(mediaItem)"
                  :media="mediaItem"
                  :active="isMediaItemsSelected(mediaItem)"
                />
              </div>
            </div>
          </template>
        </HMPaginatedTable>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('MEDIA_LIBRARY.LABEL.EMBED')"
          @close="$emit('close')"
        >
          <template slot="submit">
            <HMButton
              color="primary"
              @click="mediaSelected"
              :loading="mediaLoading"
            >
              {{ $t('GENERAL.BUTTON.SAVE') }}
            </HMButton>
          </template>
        </HMModalFooter>
      </div>
    </div>
  </div>
</template>

<script>
import { get, cloneDeep } from 'lodash';

import api from '@/core/api/modules/media-libraries';
import MediaItemCard from '@/web/components/media-library/MediaItemCard.vue';
import MediaSearchSection from '@/web/components/media-library/MediaSearchSection.vue';

export default {
  components: {
    MediaItemCard,
    MediaSearchSection,
  },
  props: {
    media: {
      type: Object,
      default() {
        return {
          id: null,
          title: null,
          media: null,
          instructor: null,
          options: [],
          description: null,
        };
      },
    },
    showEditMedia: {
      type: Boolean,
      default: true,
    },
    refreshMedia: {
      type: Function,
      default: () => Promise.resolve(),
    },
    showSelectMedia: {
      type: Boolean,
      default: false,
    },
    mediaLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formModel: {},
      formError: null,
      inProgress: false,
      searchQuery: {},
      mediaItemsSelected: [],
    };
  },
  methods: {
    navigateToAddMediaView(media) {
      if (this.showEditMedia) {
        this.$router.push({ name: 'media-library-add', params: { media } });
      } else {
        this.$parent.$emit('media-added', media);
      }
      this.$emit('close');
    },
    mediaModelToFormModel(media) {
      const formModel = cloneDeep(media);
      formModel.options = formModel.options.map(
        ({ option_id, category_name, option_name }) => ({
          id: option_id,
          name: `${category_name} - ${option_name}`,
        })
      );
      return formModel;
    },
    isMediaItemsSelected(id) {
      return this.mediaItemsSelected.indexOf(id) > -1;
    },
    toggleMediaItem(mediaItemId) {
      const index = this.mediaItemsSelected.indexOf(mediaItemId);
      if (index === -1) {
        this.mediaItemsSelected.push(mediaItemId);
      } else {
        this.mediaItemsSelected.splice(index, 1);
      }
    },
    mediaSelected() {
      this.$parent.$emit('media-selected', this.mediaItemsSelected);
      this.$emit('close');
    },
  },
  mounted() {
    this.formModel = this.mediaModelToFormModel(this.media);
    this.$trackOnPage('teacher open select media');
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.media-form-modal--lg {
  @include media-breakpoint-up(lg) {
    width: 900px;
  }
}

.hm-min-height-medium {
  min-height: 650px;
}
</style>
